/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable max-len */
import { CreditCardFilled } from '@ant-design/icons';
import { message, Row } from 'antd';
import cn from 'classnames';
import { Form, Formik } from 'formik';
import React, { HTMLProps, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';

import Button from '~/components/Button/Button';
import { Option } from '~/components/fields/OptionField/OptionField';
import TextField from '~/components/fields/TextField/TextField';
import { Text } from '~/components/Typo/Typo';
import { Country } from '~/entities/schemas/country';
import { logger } from '~/utils/func/logger';
import { RapidApiService } from '~/services/RapidApiService';
import { FontWeight, TextVariants } from '~/theme/constants';
// import { City } from '~/entities/schemas/city';

import './AddressForm.scss';

export interface AddressFormProps extends HTMLProps<HTMLFormElement> {
  handleSubmit: (values: any) => void;
  selectedItem?: number;
  loading?: boolean;
}

const AddressForm: React.FC<AddressFormProps> = ({ handleSubmit, loading }) => {
  const { t } = useTranslation();

  const validate = Yup.object({
    // city: Yup.string().required(t('addressForm:cityRequired')),
    // citySelected: Yup.string().required(t('addressForm:cityRequired')),
    cityEnter: Yup.string().required(t('addressForm:cityRequired')),
    address: Yup.string().required(t('addressForm:addressRequired')),
    state: Yup.string().required(t('addressForm:stateRequired')),
    country: Yup.string().required(t('addressForm:countryRequired')),
    zipcode: Yup.string().required(t('addressForm:zipcodeRequired')),
  });

  const [countries, setCountries] = useState<Option[]>([]);
  const [gettingCountries, setGettingCountries] = useState<boolean>(false);

  const [initialCountries, setInitialCountries] = useState<Country[]>([]);

  const [cities, setCities] = useState<Option[]>([]);
  const [gettingCities, setGettingCities] = useState<boolean>(false);

  // const [initialCities, setInitialCities] = useState<City[]>([]);

  const handleChangeCountry = useCallback(
    (event: any, formik: any) => {
      const getCountry = initialCountries.find(e => e.name === event.target.value);

      handleGetCities(getCountry?.code as string);
      formik.setFieldValue('country', event.target.value);
    },
    [initialCountries],
  );

  const handleChangeCity = useCallback((event: any, formik: any) => {
    formik.setFieldValue('citySelected', event.target.value);
  }, []);

  const handleGetCountries = useCallback(async () => {
    setGettingCountries(true);
    try {
      const res = await RapidApiService.getCountries();
      logger.debug('res RapidApiService', { prefix: 'AddressForm', data: res });

      let countryRefactor: Option;
      const countriesRefactor: Option[] = [];
      const defaultCountry = { value: '', text: t('addressForm:selectCountry') };
      countriesRefactor.push(defaultCountry);
      for (const country of res.data) {
        countryRefactor = { value: country.name, text: country.name };
        countriesRefactor.push(countryRefactor);
      }
      setInitialCountries(res.data);
      setCountries(countriesRefactor);
      setGettingCountries(false);
    } catch (error: any) {
      setGettingCountries(false);
      message.error(t('addressForm:unableToGetCountryList'));
    }
  }, []);

  const handleGetCities = useCallback(async (countryId: string) => {
    setGettingCities(true);
    try {
      const res = await RapidApiService.getCities(countryId);

      let cityRefactor: Option;
      const citiesRefactor: Option[] = [];
      const defaultCity = { value: '', text: t('addressForm:selectCity') };
      citiesRefactor.push(defaultCity);
      for (const city of res.data) {
        cityRefactor = { value: city.name, text: city.name, extra: city.region };
        citiesRefactor.push(cityRefactor);
      }
      // setInitialCities(res.data);
      setCities(citiesRefactor);
      setGettingCities(false);
    } catch (error: any) {
      setGettingCities(false);
      message.error(t('addressForm:unableToGetCitiesList'));
    }
  }, []);

  useEffect(() => {
    // handleGetCountries();
  }, []);

  return (
    <div className="address-payment-form">
      <div className={cn('caption-wrapper')}>
        <Text className="caption" size="p" weight={FontWeight.MEDIUM} variant={TextVariants.PRIMARY}>
          {t('addressForm:enterYourBillingAddress')}
        </Text>
      </div>
      <div className="form-wrapper">
        <Formik
          onSubmit={values => {
            handleSubmit(values);
          }}
          initialValues={{
            // citySelected: '',
            cityEnter: '',
            address: '',
            state: '',
            country: '',
            zipcode: '',
          }}
          enableReinitialize
          validationSchema={validate}
        >
          {formik => (
            <Form>
              <TextField
                name="country"
                type="text"
                className="text-field-card-form"
                label={t('addressForm:country')}
                placeholder={t('addressForm:country')}
                suffixIcon={<CreditCardFilled className="suffix-icon" />}
                height={30}
                disabled={loading}
              />
              {/* {gettingCountries ? (
                <Loader />
              ) : (
                <OptionField
                  name="country"
                  optionValues={countries}
                  value={formik.values.country}
                  onChange={(event: any) => handleChangeCountry(event, formik)}
                  height={35}
                  className="text-field-card-form"
                  label={t('addressForm:country')}
                  placeholder={t('addressForm:country')}
                  suffixIcon={<CreditCardFilled className="suffix-icon" />}
                  disabled={loading}
                />
              )} */}
              {/* <TextField
                name="citySelected"
                type="text"
                className="text-field-card-form"
                label={t('addressForm:city')}
                placeholder={t('addressForm:city')}
                suffixIcon={<CreditCardFilled className="suffix-icon" />}
                height={30}
                disabled={loading}
              /> */}
              {formik.values.country !== '' ? (
                <Row justify="center">
                  {/* <Col lg={11} xs={24}>
                    {gettingCities ? (
                      <Loader />
                    ) : (
                      <OptionField
                        name="citySelected"
                        optionValues={cities}
                        value={formik.values.citySelected}
                        onChange={(event: any) => handleChangeCity(event, formik)}
                        height={35}
                        className="text-field-card-form"
                        label={t('addressForm:select')}
                        placeholder={t('addressForm:select')}
                        suffixIcon={<CreditCardFilled className="suffix-icon" />}
                        disabled={loading}
                      />
                    )}
                  </Col> */}
                  {/* <Col lg={2} xs={24}>
                    <Row justify="center">
                      <Text>{t('addressForm:or')}</Text>
                    </Row>
                  </Col> */}
                  {/* <Col lg={11} xs={24}>
                    <TextField
                      name="cityEnter"
                      type="text"
                      className="text-field-card-form"
                      label={t('addressForm:enter')}
                      placeholder={t('addressForm:city')}
                      suffixIcon={<CreditCardFilled className="suffix-icon" />}
                      height={30}
                      disabled={loading}
                    />
                  </Col> */}
                </Row>
              ) : (
                <div></div>
              )}

              <TextField
                name="cityEnter"
                type="text"
                className="text-field-card-form"
                label={t('addressForm:enter')}
                placeholder={t('addressForm:city')}
                suffixIcon={<CreditCardFilled className="suffix-icon" />}
                height={30}
                disabled={loading}
              />

              <TextField
                name="address"
                type="text"
                className="text-field-card-form"
                label={t('addressForm:address')}
                placeholder={t('addressForm:address')}
                suffixIcon={<CreditCardFilled className="suffix-icon" />}
                height={30}
                disabled={loading}
              />
              <TextField
                name="state"
                type="text"
                className="text-field-card-form"
                label={t('addressForm:state')}
                placeholder={t('addressForm:state')}
                suffixIcon={<CreditCardFilled className="suffix-icon" />}
                height={30}
                disabled={loading}
              />
              <TextField
                name="zipcode"
                type="text"
                className="text-field-card-form"
                label={t('addressForm:zipCode')}
                placeholder={t('addressForm:zipCode')}
                suffixIcon={<CreditCardFilled className="suffix-icon" />}
                height={30}
                disabled={loading}
              />
              <div className="submit-button-wrapper">
                <Button
                  title={t('addressForm:send')}
                  size="block"
                  rounded
                  type="submit"
                  disabled={loading}
                  loading={loading}
                />
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default AddressForm;
